module.exports = __webpack_public_path__ + "img/enfoires_2021.c4ef67bd.jpg";